import type { ContactIdentity } from "../../../@types/portalAluno";
import { escapeHtml } from "../../html";

export const buildContactEmailBody = (
  identity: ContactIdentity,
  message: string
) => {
  const loginText = identity.login?.trim()
    ? `, identificação ${escapeHtml(identity.login.trim())}`
    : "";

  return `<p>O usuário ${escapeHtml(identity.name)}${loginText}, e-mail ${escapeHtml(
    identity.email
  )}, enviou a seguinte mensagem:<br>${escapeHtml(message).replace(
    /\r?\n/g,
    "<br>"
  )}</p>`;
};
